import { Navigate } from 'react-router-dom';
import storage from '/src/utils/storage';

// Admin gate based on the RBAC system: `is_admin` is computed backend-side
// from membership in the reserved "Administrator" role (id 0), see
// app/api/middleware.py::require_admin / role_service.py::is_user_admin.
function RequireAdmin({ children }) {
    const currentUser = storage('local').get('user');

    if (!currentUser?.is_admin) {
        return <Navigate to="/404" replace />;
    }

    return children;
}

export default RequireAdmin;
